module.exports = __webpack_public_path__ + "img/hk_room_floorplan_03_en.b52e5f64.png";